<div
  [ngClass]="{ 'cov-main-application-view-rendered': viewRendered() }"
  class="cov-main-application"
>
  <!-- Navigation -->
  <div class="cov-navigation d-print-none" [class.cov-navigation-collapsed]="!navigationExpanded()">
    <div class="logo-area">
      <cov-logo />
    </div>

    @if (currentUserOrImpersonateUser$ | async) {
      <cov-search-bar class="w-100 d-lg-none" id="cov-search" />
    }
    <cov-mobile-navigation class="d-block d-lg-none ms-auto" />
    <button class="cov-navigation-expander" (click)="onNavigationExpandButtonClick()">
      <cov-icon
        class="cov-navigation-expander-icon"
        matSuffix
        [iconName]="!navigationExpanded() ? IconName.CHEVRON_RIGHT : IconName.CHEVRON_LEFT"
      ></cov-icon>
    </button>
    <cov-sidebar-navigation
      class="d-none d-lg-block"
      [expanded]="navigationExpanded()"
    ></cov-sidebar-navigation>
  </div>

  <!-- Content -->
  <div class="cov-content-container">
    @if (!disableTopBar()) {
      <cov-top-bar class="mb-1 mb-lg-3" />
    }
    @if (disableTopBar()) {
      @if (pageTitle$ | async; as pageTitle) {
        <h1 class="cov-page-title-standalone">{{ pageTitle.key | transloco:pageTitle.params }}</h1>
      }
    }

    @if (pageTitle$ | async; as pageTitle) {
      <h1 class="cov-page-title-mobile">{{ pageTitle.key | transloco:pageTitle.params }}</h1>
    }
    <mat-sidenav-container class="cov-content">
      <mat-sidenav-content class="cov-site-content">
        <!-- actual page content -->
        <router-outlet />
      </mat-sidenav-content>
      <mat-sidenav class="global-side-panel" mode="over" position="end" #sidenav>
        <cov-icon
          class="close-button absolute"
          [iconName]="IconName.CLOSE"
          (click)="sidepanelService.closeWithOutResponse()"
        ></cov-icon>
        @if (sidepanelService.partlyClosedAvailable()) {
          <div
            class="side-panel-toggle d-flex position-absolute justify-content-end align-items-center p-1"
            (click)="sidepanelService.closePartly()"
          >
            <cov-icon [iconName]="IconName.CHEVRON_RIGHT" />
          </div>
        }
        <!-- all side panel content is projected here -->
        <div cdkPortalOutlet></div>
      </mat-sidenav>
    </mat-sidenav-container>
    <cov-footer />
  </div>
</div>
@if (currentUserOrImpersonateUser$ | async) {
  <cov-floating-inquiry-button
    (click)="openInquirySideDrawer()"
    [ngClass]="{hidden:sidepanelService.isOpen()}"
  />
}
